<template>
    <div>
        <div style="width:100%" v-if="!imageType">

            <!-- <el-radio-group class="image-source" v-model="sourceType">
                <el-radio-button label="standard"><i class="nucfont inuc-xitongguanli"></i>{{$t('res.standardLib')}}
                </el-radio-button>
                <el-radio-button label="user"><i class="nucfont inuc-person"></i>{{$t('res.userLib')}}
                </el-radio-button>
            </el-radio-group> -->
            <div class="select-image-source">
                <p class="label">{{$t('paper.imgSourceTip')}}：</p>
                <div class="choose">
                    <div class="choose-item" @click="sourceType = 'standard'" :class="{'active': sourceType === 'standard'}">
                        <label class="image-source-title"><i class="nucfont inuc-xitongguanli"></i> {{$t('res.standardLib')}}
                        </label>
                    </div>
                    <div class="choose-item" @click="sourceType = 'user'" :class="{'active': sourceType === 'user'}">
                        <label class="image-source-title">
                            <i class="nucfont inuc-person"></i> {{$t('res.userLib')}}
                        </label>
                    </div>
                </div>
            </div>
            <div class="btn-sure">
                <el-button type="primary" style="padding: 14px 50px;font-size: 18px;" @click="startPaper">{{$t('paper.startPaper')}}</el-button>
            </div>
        </div>
        <component
                    :is="componentName"
                    :passLine = "passLine"
                    :paperName= "paperName"
                    :type= "type"
                    :knowledgeName= "knowledgeName"
                    :forLevel= "forLevel"
                    :difficulty= "difficulty"
                    :pattern= "pattern"
                ></component>

    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import api from '@/api';
    import userImageLib from '../Components/UserImageLib.vue'
    import standardImageLib from '../Components/StandardImageLib.vue'
    export default {
        props: ['passLine','paperName','pattern','type','knowledgeName','forLevel','difficulty'],
        data() {
            return {
                ruleForm:{
                    checkView:'1',
                    safeCount:0,
                    topicScore:2,
                },
                safeTotal:0,
                rules:{
                    checkView:{required: true },
                    topicScore:{required: true, message: this.$t('tip.questionScore'), trigger: 'change' },
                    safeCount:{required: true, message: this.$t('paper.warnEmpty'), trigger: 'change' },
                },
                kpList:[],
                kpSelected:[],
                kpShow:true,
                totalNum:0,
                sourceType: 'standard',
                imageType: '',
                 methodInfo: [{
                    prop: 'Auto',
                    name: this.$t('paper.buildupSmart'),
                    tooltip: this.$t('paper.randomGenPaper')
                }, {
                    prop: 'Manual',
                    name: this.$t('paper.buildupChoose'),
                    tooltip: this.$t('paper.chooseGenPaper')
                }]
            }
        },
        created() {
            this.selectViewChange(1);
        },
        computed: {
            ...mapGetters([
                'knowledgeMenu',
            ]),
            componentName() {
                if (this.imageType === 'standard') {
                    return 'standardImageLib';
                } else if (this.imageType === 'user') {
                    return 'userImageLib';
                }
            },
        },
        methods: {
            startPaper(){
                console.log(this.sourceType)
                this.imageType = this.sourceType
            },
            selectViewChange(value) {
                api.getKPImageCount(value).then(res => {
                        let data=res.package;
                        this.kpList=data.kpList;
                        this.kpList.forEach(v => {
                            this.$set(v,'selected',false)
                            this.$set(v,'dangerNum',0)
                            this.$set(v,'bagNum',0)
                        })
                        this.safeTotal=data.safeCount;
                });
                this.kpSelected=[];
                this.totalNum=this.ruleForm.safeCount||0;
            },
            selectTip(index){
                if(!this.kpList[index].selected){
                    this.kpList[index].selected=true;
                    this.$set(this.kpList,index,this.kpList[index]);
                    let flag=this.kpSelected.find(v=>v.id==this.kpList[index].id)
                    if(!flag){
                        this.kpSelected.push(this.kpList[index])
                    }
                }
            },
            deleteKP(index,id){
                this.kpSelected.splice(index,1);
                this.kpList.forEach(item=>{
                    if(item.id==id){
                        item.selected=false;
                        item.dangerNum=0;
                        item.bagNum=0;
                    }
                })
                this.handleChange()
            },
            handleChange(value) {
                let totalTip=0
                this.kpSelected.forEach(item=>{
                    totalTip +=(item.dangerNum ||0) + (item.bagNum ||0);
                })
                this.totalNum=totalTip + (this.ruleForm.safeCount||0);
            },
            lastStep() {
                this.$emit('last-step');
            },

        },
        watch: {},
        components: {userImageLib, standardImageLib}
    }
</script>
<style lang="scss" scoped>
    .select-image-source{
        width: 50%;
        margin-left: 25%;
        margin-top: 10%;
        margin-bottom: 50px;
        .label{
            margin-bottom: 20px;
            font-size: 18px;
        }

    }
    .choose{
        display: flex;
        justify-content: space-between;
    }
    .choose-item {
        position: relative;
        width: 40%;
        height: 100px;
        line-height: 100px;
        border: solid 3px #73d2fe;
        text-align: center;
        // margin-right: 30px;
        cursor: pointer;
        // background: url(../../assets/images/teacher/bg_grid.jpg) no-repeat center;
        background: url('../../../assets/images/teacher/bg_grid.jpg') no-repeat center;

        &:before {
            content: '';
            position: absolute;
            top: -3px;
            left: -3px;
            bottom: -3px;
            right: -3px;
            background-color: #22b9ff;
            opacity: 0;
            transition: all .3s;
        }

        &:hover, &.active {
            &:before {
                opacity: 1;
            }
            .image-source-title{
                color: #fff;
            }

        }
        .image-source-title {
            position: relative;
            letter-spacing: 1px;
            color: #22b9ff;
            font-size: 20px;
            .nucfont{
                font-size: 20px;
            }
        }
    }
    .btn-sure{
        // margin-block: 20px auto;
        text-align: center
    }

</style>
